import React, {
  useContext,
  useEffect,
  useState
} from 'react';
import {
  useParams,
} from 'react-router-dom';
import axios from 'axios';
import { SidebarContext } from '../../../layouts/Technician/index';
import styles from './index.module.scss';
import  Quotation  from './Quotation';


interface Props {}


interface OrderService {
  _id: string,
  userId: string,
  applyJobId: string,
  description: string,
  customer: {
    name: string,
    phone: string,
    address: string,
    province: string,
    district: string,
    subDistrict: string,
    postCode: string,
    lat: number,
    lng: number
  },
  images: Object[]
  orderNo: string,
  category: String,
  status: string,
  updatedAt: string,
  createdAt: string,
}

const TechnicianInvoiceDetails: React.FC<Props> = () => {
  const {setCurrentItem, setCurrentPage} = useContext(SidebarContext)
  const { id } = useParams()

  const [loading, setLoading] = useState<Boolean>(true)
  const [orderId, setOrderId] = useState<String>()

useEffect(() => {
    if (id) setCurrentItem(id)
    setOrderId(id);
    setCurrentPage('invoices-detail')
  }, [id]);

  

  return (
    <>
      <div className={styles.quotation}>
        <Quotation orderId={orderId} />
      </div>
    </>
  );
}

export default TechnicianInvoiceDetails;
